import React, { useEffect } from 'react'
import { Modal, Form, Input, Select } from 'antd'
import { User } from '../../types'

const { Option } = Select

interface UserFormModalProps {
  visible: boolean
  onCancel: () => void
  onSubmit: (userData: any) => Promise<void>
  user?: User | null
  loading?: boolean
}

const UserFormModal: React.FC<UserFormModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  user,
  loading = false
}) => {
  const [form] = Form.useForm()
  const isEdit = !!user

  useEffect(() => {
    if (visible) {
      if (isEdit && user) {
        form.setFieldsValue({
          username: user.username,
          role: user.role,
        })
      } else {
        form.resetFields()
      }
    }
  }, [visible, user, isEdit, form])

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      await onSubmit(values)
      form.resetFields()
    } catch (error) {
      // 表单验证失败或提交失败
      console.error('Form submission error:', error)
    }
  }

  const roleOptions = [
    { value: 'ADMIN', label: '管理员' },
    { value: 'BUSINESS', label: '业务员' },
    { value: 'PACKER', label: '装箱员' }
  ]

  return (
    <Modal
      title={isEdit ? '编辑用户' : '新增用户'}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}

    >
      <Form
        form={form}
        layout="vertical"
        preserve={false}
      >
        <Form.Item
          name="username"
          label="用户名"
          rules={[
            { required: true, message: '请输入用户名' },
            { min: 3, message: '用户名至少3个字符' },
            { max: 50, message: '用户名最多50个字符' },
            { pattern: /^[a-zA-Z0-9_]+$/, message: '用户名只能包含字母、数字和下划线' }
          ]}
        >
          <Input placeholder="请输入用户名" disabled={isEdit} />
        </Form.Item>

        {!isEdit && (
          <Form.Item
            name="password"
            label="密码"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6个字符' },
              { max: 100, message: '密码最多100个字符' }
            ]}
          >
            <Input.Password placeholder="请输入密码" />
          </Form.Item>
        )}

        <Form.Item
          name="role"
          label="角色"
          rules={[{ required: true, message: '请选择角色' }]}
        >
          <Select placeholder="请选择角色">
            {roleOptions.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default UserFormModal